<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <p class="head">Part B</p>
      <div class="sub-header d-flex align-center justify-space-between">
        <p>How You want to distribute your wealth - Your investment details will be auto fetched from Investment Dashboard. Please ensure you have updated your investment details.</p>
        <!-- <p class="content complete">Completed</p> -->
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-app id="sub-accordian">
        <v-expansion-panels>
                   <!-- Deposit Type -->
          <v-expansion-panel v-if="deposit_items.length">
            <v-expansion-panel-header>
              <p class="sub-title">Asset Type- Deposits</p>
             <!--  <div class="img-box" v-if="isHidden">
                <v-img
                  max-height="25"
                  max-width="30"
                  :src="update_pic"
                  :lazy-src="update_pic"
                >
                </v-img>

                <v-img
                  max-height="25"
                  max-width="30"
                  :src="delete_pic"
                  :lazy-src="delete_pic"
                >
                </v-img>
              </div> -->
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Deposit COntents -->

              <v-layout row class="padding">
                <div
                  class="mx-auto pa-2 text-center text-wrap"
                  max-width="1000"
                  id="limited-products"
                >
                  <!-- <input type="checkbox"  v-model="checked_nominee"    @click="updateNominee()">
                   <label style="color:#2e4371" :class="{ 'checked_nominee': update_nominee }"> UPDATE NOMINEE</label> -->
                  <label v-if="(!isHidden) && (deposit_nominee.length != 0)" class="label-checkbox" :class="{ 'checked_nominee': update_nominee }">
                    <input type="checkbox" 
                    v-model="update_nominee"  
                    class="check-day" 
                    @click="updateAllNominee()">
                   Apply same nominee details for all
                  </label>
                  <v-data-table
                    :headers="headers1"
                    :items="deposit_items"
                    :hide-default-footer="true"
                    v-if="!isHidden"
                  >
                   <template v-slot:[`item.nominee_name`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.nominee_name }}</div>
                  </template>
                  <template v-slot:[`item.relationship`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.relationship }}</div>
                  </template>
                  <template v-slot:[`item.share_to_bequeath`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.share_to_bequeath }}</div>
                  </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-img
                        max-height="15"
                        max-width="16"
                        :src="edit_pic"
                        @click="editItem(item)"
                        style="cursor: pointer"
                      ></v-img>
                    </template>    
                  </v-data-table>
                </div>
              </v-layout>
              <v-form
                ref="form"
                id="deposit_details"
                @submit.prevent
                lazy-validation
              >
              <div class="deposits-content" v-if="isHidden">
                <v-row class="deposits-top-content">
                  <v-col md="6" sm="6" cols="12">
                    <p>DEPOSIT TYPE</p>
                    <div class="input-field-box">
                      <v-text-field
                        type="text"
                        v-model="form_name"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col md="6" sm="6" cols="12">
                    <p>ACCOUNT NO.</p>
                      <div class="input-field-box">
                      <v-text-field
                        type="text"
                        v-model="account_no"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
                <div class="">
                  <v-row class="deposits-second-content" v-for="(item,index) in deposit_nominee" :key="index">
                    <v-col md="4">
                      <p>NOMINEE NAME {{index+1}}</p>
                      <div class="input-field-box" v-if="item.type == 'add-more'">
                        <v-select
                          v-model="item.name"
                          :items="item.members"
                          item-value="text"
                          item-text="text"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                          @change="getRelationship($event,index)"
                        ></v-select>
                      </div>
                       <div class="input-field-box" v-else>
                        <v-text-field
                          type="text"
                          v-model="item.name"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                      </div>
                    </v-col>
                     <v-col class="col-sm-6 col-md-4">
                      <p>RELATONSHIP</p>
                      <v-select  
                        class="relation_col"
                        v-model="item.relation"
                        :items="relation_list"
                        id="will_creation_memeber"
                        item-value="name"
                        item-text="name"
                        placeholder="Choose Relation"
                        solo
                      ></v-select>
                    </v-col> 
                    <v-col md="4" sm="6" cols="12">
                      <p>PERCENTAGE (%)</p>
                       <v-text-field
                          type="number"
                          v-model="item.percentage"
                          outlined
                          dense
                          placeholder="XX-%"
                          solo
                        ></v-text-field>
                    </v-col>
                     <a style="color:red;" @click="removeNominee(index)">- REMOVE </a>
                  </v-row>
                  <div class="hor-line"></div>
                </div>
                <button @click="addNominee('add-more')" style="color:blue;">+ ADD NOMINEE</button
                        >
                <button @click="addNominee('add-other')" style="color:orange;margin-left:20px">+ ADD OTHER NOMINEE</button
                        >
                <div class="button-group">
                  <button class="btn save-btn" @click="saveDetails('deposit')">
                    SAVE DETAILS
                  </button>
                  <button class="btn cancle-btn" @click="cancelDetails">CANCEL</button>
                </div>
              </div>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
            <!-- Stock Type -->
          <v-expansion-panel v-if="stock_items.length">
            <v-expansion-panel-header
              ><p class="sub-title">Asset Type- Stocks</p>
              <div class="img-box" v-if="isStockHidden">
                <v-img
                  max-height="25"
                  max-width="30"
                  :src="update_pic"
                  :lazy-src="update_pic"
                >
                </v-img>

                <v-img
                  max-height="25"
                  max-width="30"
                  :src="delete_pic"
                  :lazy-src="delete_pic"
                >
                </v-img>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Stocks Details -->
              <v-layout row class="padding">
                <div
                  class="mx-auto pa-2 text-center text-wrap"
                  max-width="1000"
                  id="limited-products"
                >
                  <v-data-table
                    :headers="headers2"
                    :items="stock_items"
                    :hide-default-footer="true"
                    v-if="!isStockHidden"
                  >
                   <template v-slot:[`item.nominee_name`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.nominee_name }}</div>
                  </template>
                  <template v-slot:[`item.relationship`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.relationship }}</div>
                  </template>
                  <template v-slot:[`item.share_to_bequeath`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.share_to_bequeath }}</div>
                  </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-img
                        max-height="15"
                        max-width="16"
                        :src="edit_pic"
                        @click="editStockItem(item)"
                        style="cursor: pointer"
                      ></v-img>
                    </template>
                  </v-data-table>
                </div>
              </v-layout>
               <v-form
                ref="form"
                id="stock_details"
                @submit.prevent
                lazy-validation
              >
              <div class="deposits-content" v-if="isStockHidden">
                <v-row class="deposits-top-content">
                  <v-col md="6" sm="6" cols="12">
                    <p>STOCK TYPE</p>
                    <v-text-field
                        type="text"
                        v-model="stock_type"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                  </v-col>
                  <v-col md="6" sm="6" cols="12">
                    <p>STOCK NAME</p>
                  <v-text-field
                        type="text"
                        v-model="stock_name"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                  </v-col>
                </v-row>
                <div class="">
                  <v-row class="deposits-second-content" v-for="(item,index) in deposit_nominee" :key="index">
                    <v-col md="4">
                      <p>NOMINEE NAME {{index+1}}</p>
                       <div class="input-field-box" v-if="item.type == 'add-more'">
                        <v-select
                          v-model="item.name"
                          :items="item.members"
                          item-value="text"
                          item-text="text"
                          @change="getRelationship($event,index)"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-select>
                      </div>
                       <div class="input-field-box" v-else>
                        <v-text-field
                          type="text"
                          v-model="item.name"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col class="col-sm-6 col-md-4">
                      <p>RELATONSHIP</p>
                      <v-select  
                        class="relation_col"
                        v-model="item.relation"
                        :items="relation_list"
                        id="will_creation_memeber"
                        item-value="name"
                        item-text="name"
                        placeholder="Choose Relation"
                        solo
                      ></v-select>
                    </v-col> 
                    <v-col md="4" sm="6" cols="12">
                      <p>PERCENTAGE (%)</p>
                      <v-text-field
                          type="number"
                          v-model="item.percentage"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                    </v-col>
                      <a style="color:red;" @click="removeNominee(index)">- REMOVE </a>
                  </v-row>
                  <div class="hor-line"></div>
                </div>
                <button @click="addNominee('add-more')" style="color:blue;">+ ADD NOMINEE</button
                        >
                <button @click="addNominee('add-other')" style="color:orange;margin-left:20px">+ ADD OTHER NOMINEE</button
                        >
                    <div class="button-group">
                  <button class="btn save-btn" @click="saveDetails('stock')">
                    SAVE DETAILS
                  </button>
                  <button class="btn cancle-btn" @click="cancelDetails()">CANCEL</button>
                </div>
              </div>
               </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
           <!-- Mutual fund Type -->
          <v-expansion-panel v-if="mutual_fund_items.length">
            <v-expansion-panel-header
              ><p class="sub-title">Asset Type- Mutual Funds</p>
              <div class="img-box" v-if="isFundHidden">
                <v-img
                  max-height="25"
                  max-width="30"
                  :src="update_pic"
                  :lazy-src="update_pic"
                >
                </v-img>
                
                <v-img
                  max-height="25"
                  max-width="30"
                  :src="delete_pic"
                  :lazy-src="delete_pic"
                >
                </v-img>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Mutual  Details -->
              <v-layout row class="padding">
                <div
                  class="mx-auto pa-2 text-center text-wrap"
                  max-width="1000"
                  id="limited-products"
                >
                  <v-data-table
                    :headers="headers3"
                    :items="mutual_fund_items"
                    :hide-default-footer="true"
                    v-if="!isFundHidden"
                  >
                   <template v-slot:[`item.nominee_name`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.nominee_name }}</div>
                  </template>
                  <template v-slot:[`item.relationship`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.relationship }}</div>
                  </template>
                  <template v-slot:[`item.share_to_bequeath`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.share_to_bequeath }}</div>
                  </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-img
                        max-height="15"
                        max-width="16"
                        :src="edit_pic"
                        @click="editFundItem(item,index)"
                        style="cursor: pointer"
                      ></v-img>
                    </template>
                  </v-data-table>
                </div>
              </v-layout>
              <v-form
                ref="form"
                id="fund_details"
                @submit.prevent
                lazy-validation
              >
              <div class="deposits-content" v-if="isFundHidden">
                <v-row class="deposits-top-content" >
                  <v-col md="6" sm="6" cols="12">
                    <p>FUND NAME</p>
                    <v-text-field
                        type="text"
                        v-model="form_name"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                  </v-col>
                  <v-col md="6" sm="6" cols="12">
                    <p>FOLIO NO.</p>
                 <v-text-field
                        type="text"
                        v-model="folio_no"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                  </v-col>
                </v-row>
                <div class="">
                  <v-row class="deposits-second-content"  v-for="(item,index) in deposit_nominee" :key="index">
                    <v-col md="4">
                      <p>NOMINEE NAME {{index+1}}</p>
                       <div class="input-field-box" v-if="item.type == 'add-more'">
                        <v-select
                          v-model="item.name"
                          :items="item.members"
                          item-value="text"
                          item-text="text"
                          outlined
                           @change="getRelationship($event,index)"
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-select>
                      </div>
                       <div class="input-field-box" v-else>
                        <v-text-field
                          type="text"
                          v-model="item.name"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                      </div>
                    </v-col>
                     <v-col class="col-sm-6 col-md-4">
                      <p>RELATONSHIP</p>
                      <v-select  
                        class="relation_col"
                        v-model="item.relation"
                        :items="relation_list"
                        id="will_creation_memeber"
                        item-value="name"
                        item-text="name"
                        placeholder="Choose Relation"
                        solo
                      ></v-select>
                    </v-col> 
                    <v-col md="4" sm="6" cols="12">
                      <p>PERCENTAGE (%)</p>
                       <v-text-field
                          type="number"
                          v-model="item.percentage"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                    </v-col>
                  <a style="color:red;" @click="removeNominee(index)">- REMOVE </a>
                  </v-row>
                  <div class="hor-line"></div>
                </div>
                 <button @click="addNominee('add-more')" style="color:blue;">+ ADD NOMINEE</button
                        >
                <button @click="addNominee('add-other')" style="color:orange;margin-left:20px">+ ADD OTHER NOMINEE</button
                        >
                <div class="button-group">
                  <button class="btn save-btn" @click="saveDetails('mutual_fund')">
                    SAVE DETAILS
                  </button>
                  <button class="btn cancle-btn" @click="cancelDetails()">CANCEL</button>
                </div>
              </div>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- Bullion Type -->
          <v-expansion-panel v-if="bullion_items.length">
            <v-expansion-panel-header
              ><p class="sub-title">Asset Type- Bullion</p>
              <div class="img-box" v-if="isBullionHidden">
                <v-img
                  max-height="25"
                  max-width="30"
                  :src="update_pic"
                  :lazy-src="update_pic"
                >
                </v-img>

                <v-img
                  max-height="25"
                  max-width="30"
                  :src="delete_pic"
                  :lazy-src="delete_pic"
                >
                </v-img>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Bullion Details -->
              <v-layout row class="padding">
                <div
                  class="mx-auto pa-2 text-center text-wrap"
                  max-width="1000"
                  id="limited-products"
                >
                  <v-data-table
                    :headers="headers4"
                    :items="bullion_items"
                    :hide-default-footer="true"
                    v-if="!isBullionHidden"
                  >
                   <template v-slot:[`item.nominee_name`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.nominee_name }}</div>
                  </template>
                  <template v-slot:[`item.relationship`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.relationship }}</div>
                  </template>
                  <template v-slot:[`item.share_to_bequeath`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.share_to_bequeath }}</div>
                  </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-img
                        max-height="15"
                        max-width="16"
                        :src="edit_pic"
                        @click="editBullionItem(item)"
                        style="cursor: pointer"
                      ></v-img>
                    </template>
                  </v-data-table>
                </div>
              </v-layout>
              <v-form
                ref="form"
                id="bullion_details"
                @submit.prevent
                lazy-validation
              >
              <div class="deposits-content" v-if="isBullionHidden">
                <v-row class="deposits-top-content" >
                  <v-col md="6" sm="6" cols="12">
                    <p>BULLION TYPE</p>
                    <v-text-field
                        type="text"
                        v-model="bullion_type"
                        outlined
                        dense
                       readonly
                      ></v-text-field>
                  </v-col>
                  <v-col md="6" sm="6" cols="12">
                    <p>QUANTITY</p>
                  <v-text-field
                        type="text"
                        v-model="bullion_quantity"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                  </v-col>
                </v-row>
                <div class="">
                  <v-row class="deposits-second-content" v-for="(item,index) in deposit_nominee" :key="index">
                    <v-col md="4">
                      <p>NOMINEE NAME {{index+1}}</p>
                       <div class="input-field-box" v-if="item.type == 'add-more'">
                        <v-select
                          v-model="item.name"
                          :items="item.members"
                          item-value="text"
                          item-text="text"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                           @change="getRelationship($event,index)"
                          solo
                        ></v-select>
                      </div>
                       <div class="input-field-box" v-else>
                        <v-text-field
                          type="text"
                          v-model="item.name"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col class="col-sm-6 col-md-4">
                      <p>RELATONSHIP</p>
                      <v-select  
                        class="relation_col"
                        v-model="item.relation"
                        :items="relation_list"
                        id="will_creation_memeber"
                        item-value="name"
                        item-text="name"
                        placeholder="Choose Relation"
                        solo
                      ></v-select>
                    </v-col> 
                    <v-col md="4" sm="6" cols="12">
                      <p>PERCENTAGE (%)</p>
                       <v-text-field
                          type="number"
                          v-model="item.percentage"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                    </v-col>
                  <a style="color:red;" @click="removeNominee(index)">- REMOVE </a>
                  </v-row>
                  <div class="hor-line"></div>
                </div>
                 <button @click="addNominee('add-more')" style="color:blue;">+ ADD NOMINEE</button
                        >
                <button @click="addNominee('add-other')" style="color:orange;margin-left:20px">+ ADD OTHER NOMINEE</button
                        >
                <div class="button-group">
                  <button class="btn save-btn" @click="saveDetails('bullion')">
                    SAVE DETAILS
                  </button>
                  <button class="btn cancle-btn" @click="cancelDetails()">CANCEL</button>
                </div>
              </div>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- Bond Type -->
          <v-expansion-panel v-if="bonds_items.length">
            <v-expansion-panel-header
              ><p class="sub-title">Asset Type- Bonds</p>
              <div class="img-box" v-if="isBondHidden">
                <v-img
                  max-height="25"
                  max-width="30"
                  :src="update_pic"
                  :lazy-src="update_pic"
                >
                </v-img>

                <v-img
                  max-height="25"
                  max-width="30"
                  :src="delete_pic"
                  :lazy-src="delete_pic"
                >
                </v-img>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Bonds Details -->
              <v-layout row class="padding">
                <div
                  class="mx-auto pa-2 text-center text-wrap"
                  max-width="1000"
                  id="limited-products"
                >
                  <v-data-table
                    :headers="headers5"
                    :items="bonds_items"
                    :hide-default-footer="true"
                    v-if="!isBondHidden"
                  >
                   <template v-slot:[`item.nominee_name`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.nominee_name }}</div>
                  </template>
                  <template v-slot:[`item.relationship`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.relationship }}</div>
                  </template>
                  <template v-slot:[`item.share_to_bequeath`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.share_to_bequeath }}</div>
                  </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-img
                        max-height="15"
                        max-width="16"
                        :src="edit_pic"
                        @click="editBondItem(item)"
                        style="cursor: pointer"
                      ></v-img>
                    </template>
                  </v-data-table>
                </div>
              </v-layout>
              <v-form
                ref="form"
                id="bond_details"
                @submit.prevent
                lazy-validation
              >
              <div class="deposits-content" v-if="isBondHidden">
                <v-row class="deposits-top-content">
                  <v-col md="6" sm="6" cols="12">
                    <p>BOND NAME</p>
                    <v-text-field
                        type="text"
                        v-model="bond_name"
                        outlined
                        dense
                       readonly
                      ></v-text-field>
                  </v-col>
                  <v-col md="6" sm="6" cols="12">
                    <p>UNITS</p>
                    <v-text-field
                        type="text"
                        v-model="bond_unit"
                        outlined
                        dense
                       readonly
                      ></v-text-field>
                  </v-col>
                </v-row>
                <div class="">
                  <v-row class="deposits-second-content" v-for="(item,index) in deposit_nominee" :key="index">
                    <v-col md="4">
                      <p>NOMINEE NAME {{index+1}}</p>
                       <div class="input-field-box" v-if="item.type == 'add-more'">
                        <v-select
                          v-model="item.name"
                          :items="item.members"
                          item-value="text"
                          item-text="text"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                           @change="getRelationship($event,index)"
                          solo
                        ></v-select>
                      </div>
                       <div class="input-field-box" v-else>
                        <v-text-field
                          type="text"
                          v-model="item.name"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                      </div>
                    </v-col>
                     <v-col class="col-sm-6 col-md-4">
                      <p>RELATONSHIP</p>
                      <v-select  
                        class="relation_col"
                        v-model="item.relation"
                        :items="relation_list"
                        id="will_creation_memeber"
                        item-value="name"
                        item-text="name"
                        placeholder="Choose Relation"
                        solo
                      ></v-select>
                    </v-col> 
                    <v-col md="4" sm="6" cols="12">
                      <p>PERCENTAGE (%)</p>
                      <v-text-field
                          type="number"
                          v-model="item.percentage"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                    </v-col>
                  <a style="color:red;" @click="removeNominee(index)">- REMOVE </a>
                  </v-row>
                  <div class="hor-line"></div>
                </div>
                <button @click="addNominee('add-more')" style="color:blue;">+ ADD NOMINEE</button
                        >
                <button @click="addNominee('add-other')" style="color:orange;margin-left:20px">+ ADD OTHER NOMINEE</button
                        >
                <div class="button-group">
                  <button class="btn save-btn" @click="saveDetails('bonds')">
                    SAVE DETAILS
                  </button>
                   <button class="btn cancle-btn" @click="cancelDetails()">CANCEL</button>
                </div>
              </div>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- Real Estate Type -->
          <v-expansion-panel v-if="realestate_items.length">
            <v-expansion-panel-header
              ><p class="sub-title">Asset Type- Real Estate</p>
              <div class="img-box" v-if="isRealEstateHidden">
                <v-img
                  max-height="25"
                  max-width="30"
                  :src="update_pic"
                  :lazy-src="update_pic"
                >
                </v-img>

                <v-img
                  max-height="25"
                  max-width="30"
                  :src="delete_pic"
                  :lazy-src="delete_pic"
                >
                </v-img>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Real Estate Details -->
              <v-layout row class="padding">
                <div
                  class="mx-auto pa-2 text-center text-wrap"
                  max-width="1000"
                  id="limited-products"
                >
                  <v-data-table
                    :headers="headers6"
                    :items="realestate_items"
                    :hide-default-footer="true"
                    v-if="!isRealEstateHidden"
                  >
                   <template v-slot:[`item.nominee_name`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.nominee_name }}</div>
                  </template>
                  <template v-slot:[`item.relationship`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.relationship }}</div>
                  </template>
                  <template v-slot:[`item.share_to_bequeath`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.share_to_bequeath }}</div>
                  </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-img
                        max-height="15"
                        max-width="16"
                        :src="edit_pic"
                        @click="editRealEstateItem(item)"
                        style="cursor: pointer"
                      ></v-img>
                    </template>
                  </v-data-table>
                </div>
              </v-layout>
              <v-form
                ref="form"
                id="realestate_details"
                @submit.prevent
                lazy-validation
              >
              <div class="deposits-content" v-if="isRealEstateHidden">
                <v-row class="deposits-top-content">
                  <v-col md="6" sm="6" cols="12">
                    <p>REAL ESTATE TYPE</p>
                   <v-text-field
                        type="text"
                        v-model="property_type"
                        outlined
                        dense
                      readonly
                      ></v-text-field>
                  </v-col>
                  <v-col md="6" sm="6" cols="12">
                    <p>NAME & ADDRESS</p>
                  <v-text-field
                        type="text"
                        v-model="state"
                        outlined
                        dense
                      readonly
                      ></v-text-field>
                  </v-col>
                </v-row>
                <div class="">
                  <v-row class="deposits-second-content" v-for="(item,index) in deposit_nominee" :key="index">
                    <v-col md="4">
                      <p>NOMINEE NAME {{index+1}}</p>
                      <div class="input-field-box" v-if="item.type == 'add-more'">
                        <v-select
                          v-model="item.name"
                          :items="item.members"
                          item-value="text"
                          item-text="text"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                           @change="getRelationship($event,index)"
                          solo
                        ></v-select>
                      </div>
                       <div class="input-field-box" v-else>
                        <v-text-field
                          type="text"
                          v-model="item.name"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col class="col-sm-6 col-md-4">
                      <p>RELATONSHIP</p>
                      <v-select  
                        class="relation_col"
                        v-model="item.relation"
                        :items="relation_list"
                        id="will_creation_memeber"
                        item-value="name"
                        item-text="name"
                        placeholder="Choose Relation"
                        solo
                      ></v-select>
                    </v-col> 
                    <v-col md="4" sm="6" cols="12">
                      <p>PERCENTAGE (%)</p>
                        <v-text-field
                          type="number"
                          v-model="item.percentage"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                    </v-col>
                  <a style="color:red;" @click="removeNominee(index)">- REMOVE </a>
                  </v-row>
                  <div class="hor-line"></div>
                </div>
                 <button @click="addNominee('add-more')" style="color:blue;">+ ADD NOMINEE</button
                        >
                <button @click="addNominee('add-other')" style="color:orange;margin-left:20px">+ ADD OTHER NOMINEE</button
                        >
                <div class="button-group">
                  <button class="btn save-btn" @click="saveDetails('real_estate')">
                    SAVE DETAILS
                  </button>
                 <button class="btn cancle-btn" @click="cancelDetails()">CANCEL</button>
                </div>
              </div>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- Commodities Type -->
          <v-expansion-panel v-if="commodities_items.length">
            <v-expansion-panel-header
              ><p class="sub-title">Asset Type- Commodities</p>
              <div class="img-box" v-if="isCommoditiesHidden">
                <v-img
                  max-height="25"
                  max-width="30"
                  :src="update_pic"
                  :lazy-src="update_pic"
                >
                </v-img>

                <v-img
                  max-height="25"
                  max-width="30"
                  :src="delete_pic"
                  :lazy-src="delete_pic"
                >
                </v-img>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Commodities Details -->
              <v-layout row class="padding">
                <div
                  class="mx-auto pa-2 text-center text-wrap"
                  max-width="1000"
                  id="limited-products"
                >
                  <v-data-table
                    :headers="headers7"
                    :items="commodities_items"
                    :hide-default-footer="true"
                    v-if="!isCommoditiesHidden"
                  >
                   <template v-slot:[`item.nominee_name`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.nominee_name }}</div>
                  </template>
                  <template v-slot:[`item.relationship`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.relationship }}</div>
                  </template>
                  <template v-slot:[`item.share_to_bequeath`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.share_to_bequeath }}</div>
                  </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-img
                        max-height="15"
                        max-width="16"
                        :src="edit_pic"
                        @click="editCommoditiesItem(item)"
                        style="cursor: pointer"
                      ></v-img>
                    </template>
                  </v-data-table>
                </div>
              </v-layout>
              <v-form
                ref="form"
                id="commodities_details"
                @submit.prevent
                lazy-validation
              >
              <div class="deposits-content" v-if="isCommoditiesHidden">
                <v-row class="deposits-top-content">
                  <v-col md="6" sm="6" cols="12">
                    <p>STOCK TYPE</p>
                    <div>
                      <v-text-field
                        type="text"
                        v-model="commodity_name"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col md="6" sm="6" cols="12">
                    <p>UNITS</p>
                    <div>
                       <v-text-field
                        type="text"
                        v-model="commodity_unit"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
                <div class="">
                  <v-row class="deposits-second-content" v-for="(item,index) in deposit_nominee" :key="index">
                    <v-col md="4">
                      <p>NOMINEE NAME {{index+1}}</p>
                      <div class="input-field-box" v-if="item.type == 'add-more'">
                        <v-select
                          v-model="item.name"
                          :items="item.members"
                          item-value="text"
                          item-text="text"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                           @change="getRelationship($event,index)"
                          solo
                        ></v-select>
                      </div>
                       <div class="input-field-box" v-else>
                        <v-text-field
                          type="text"
                          v-model="item.name"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                      </div>
                    </v-col>
                     <v-col class="col-sm-6 col-md-4">
                      <p>RELATONSHIP</p>
                      <v-select  
                        class="relation_col"
                        v-model="item.relation"
                        :items="relation_list"
                        id="will_creation_memeber"
                        item-value="name"
                        item-text="name"
                        placeholder="Choose Relation"
                        solo
                      ></v-select>
                    </v-col> 
                    <v-col md="4" sm="6" cols="12">
                      <p>PERCENTAGE (%)</p>
                       <v-text-field
                          type="number"
                          v-model="item.percentage"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                    </v-col>
                  <a style="color:red;" @click="removeNominee(index)">- REMOVE </a>
                  </v-row>
                  <div class="hor-line"></div>
                </div>
                 <button @click="addNominee('add-more')" style="color:blue;">+ ADD NOMINEE</button
                        >
                <button @click="addNominee('add-other')" style="color:orange;margin-left:20px">+ ADD OTHER NOMINEE</button
                        >
                <div class="button-group">
                  <button class="btn save-btn" @click="saveDetails('commodity')">
                    SAVE DETAILS
                  </button>
                  <button class="btn cancle-btn" @click="cancelDetails()">CANCEL</button>
                </div>
              </div>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- Private Investment Type -->
          <v-expansion-panel v-if="private_investment_items.length">
            <v-expansion-panel-header
              ><p class="sub-title">Asset Type- Private Investment</p>
              <div class="img-box" v-if="isPrivateHidden">
                <v-img
                  max-height="25"
                  max-width="30"
                  :src="update_pic"
                  :lazy-src="update_pic"
                >
                </v-img>

                <v-img
                  max-height="25"
                  max-width="30"
                  :src="delete_pic"
                  :lazy-src="delete_pic"
                >
                </v-img>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Private Investment Details -->
              <v-layout row class="padding">
                <div
                  class="mx-auto pa-2 text-center text-wrap"
                  max-width="1000"
                  id="limited-products"
                >
                  <v-data-table
                    :headers="headers8"
                    :items="private_investment_items"
                    :hide-default-footer="true"
                    v-if="!isPrivateHidden"
                  >
                   <template v-slot:[`item.nominee_name`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.nominee_name }}</div>
                  </template>
                  <template v-slot:[`item.relationship`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.relationship }}</div>
                  </template>
                  <template v-slot:[`item.share_to_bequeath`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.share_to_bequeath }}</div>
                  </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-img
                        max-height="15"
                        max-width="16"
                        :src="edit_pic"
                        @click="editPrivateItem(item)"
                        style="cursor: pointer"
                      ></v-img>
                    </template>
                  </v-data-table>
                </div>
              </v-layout>
              <v-form
                ref="form"
                id="private_details"
                @submit.prevent
                lazy-validation
              >
              <div class="deposits-content" v-if="isPrivateHidden">
                <v-row class="deposits-top-content">
                  <v-col md="6" sm="6" cols="12">
                    <p>INVESTMENT TYPE</p>
                  <v-text-field
                        type="text"
                        v-model="pms_form_name"
                        outlined
                        dense
                       readonly
                      ></v-text-field>
                  </v-col>
                  <v-col md="6" sm="6" cols="12">
                    <p>COMPANY/FUND NAME</p>
                   <v-text-field
                        type="text"
                        v-model="pms_name"
                        outlined
                        dense
                       readonly
                      ></v-text-field>
                  </v-col>
                 
                </v-row>
                <div class="">
                  <v-row class="deposits-second-content" v-for="(item,index) in deposit_nominee" :key="index">
                    <v-col md="4">
                      <p>NOMINEE NAME {{index+1}}</p>
                       <div class="input-field-box" v-if="item.type == 'add-more'">
                        <v-select
                          v-model="item.name"
                          :items="item.members"
                          item-value="text"
                          item-text="text"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                           @change="getRelationship($event,index)"
                          solo
                        ></v-select>
                      </div>
                       <div class="input-field-box" v-else>
                        <v-text-field
                          type="text"
                          v-model="item.name"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                      </div>
                    </v-col>
                     <v-col class="col-sm-6 col-md-4">
                      <p>RELATONSHIP</p>
                      <v-select  
                        class="relation_col"
                        v-model="item.relation"
                        :items="relation_list"
                        id="will_creation_memeber"
                        item-value="name"
                        item-text="name"
                        placeholder="Choose Relation"
                        solo
                      ></v-select>
                    </v-col> 
                    <v-col md="4" sm="6" cols="12">
                      <p>PERCENTAGE (%)</p>
                       <v-text-field
                          type="number"
                          v-model="item.percentage"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                    </v-col>
                  <a style="color:red;" @click="removeNominee(index)">- REMOVE </a>
                  </v-row>
                  <div class="hor-line"></div>
                </div>
                <button @click="addNominee('add-more')" style="color:blue;">+ ADD NOMINEE</button
                        >
                <button @click="addNominee('add-other')" style="color:orange;margin-left:20px">+ ADD OTHER NOMINEE</button
                        >
                <div class="button-group">
                  <button class="btn save-btn" @click="saveDetails('pms')">
                    SAVE DETAILS
                  </button>
                <button class="btn cancle-btn" @click="cancelDetails()">CANCEL</button>
                </div>
              </div>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- Other Asset Type -->
          <v-expansion-panel>
            <v-expansion-panel-header
              ><p class="sub-title">Asset Type- Other Assets (Valuables & Movable Assets)</p>
              <div class="img-box" v-if="isPrivateHidden">
                <v-img
                  max-height="25"
                  max-width="30"
                  :src="update_pic"
                  :lazy-src="update_pic"
                >
                </v-img>

                <v-img
                  max-height="25"
                  max-width="30"
                  :src="delete_pic"
                  :lazy-src="delete_pic"
                >
                </v-img>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Other Asset Details -->
              <v-layout row class="padding">
                <div
                  class="mx-auto pa-2 text-center text-wrap"
                  max-width="1000"
                  id="limited-products"
                >
                 <v-btn  v-if="!isOtherHidden" style="color:white; background:#10104a; margin-left:80%"  @click="addOtherAssets"
                      >+ Add Assets</v-btn
                    > 
                  <v-data-table
                    :headers="headers9"
                    :items="other_asset_items"
                    :hide-default-footer="true"
                    v-if="!isOtherHidden"
                  >
                   <template v-slot:[`item.nominee_name`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.nominee_name }}</div>
                  </template>
                  <template v-slot:[`item.relationship`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.relationship }}</div>
                  </template>
                  <template v-slot:[`item.share_to_bequeath`]="{ item }">
                    <div style="white-space: pre-wrap;">{{ item.share_to_bequeath }}</div>
                  </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <span>
                          <v-img  :src="edit_pic" max-height="16" max-width="16" style="cursor: pointer; margin:3px 7px -20px -3px;"  @click="editOtherItem(item)">
                            </v-img>
                          <v-img  :src="delete_pic" max-height="16" max-width="16" style="cursor: pointer; margin: 5px 1px 10px 25px;"  @click="deleteOtherItem(item)">
                            </v-img>
                      </span>
                    </template>
                  </v-data-table>
                </div>
              </v-layout>
              <v-form
                ref="form"
                id="otherassets_details"
                @submit.prevent
                lazy-validation
              >
              <div class="deposits-content" v-if="isOtherHidden">
                <v-row class="deposits-top-content">
                  <v-col md="6" sm="6" cols="12">
                    <p>ASSET TYPE</p>
                       <v-select 
                        v-model="asset_type"
                        :items="asset_types"
                        outlined
                        dense 
                        :readonly="readonly"
                        @change="$v.asset_type.touch()"                     
                      ></v-select>
                  </v-col>
                  <v-col md="6" sm="6" cols="12">
                    <p>ASSET NAME/DESCRIPTION</p>
                   <v-textarea
                        row="3"
                        v-model="asset_name"
                        outlined
                        dense
                        :readonly="readonly"
                      ></v-textarea>
                  </v-col>
                </v-row>
                <div class="">
                  <v-row class="deposits-second-content" v-for="(item,index) in deposit_nominee" :key="index">
                    <v-col md="4" >
                      <p>NOMINEE NAME {{index+1}}</p>
                        <div class="input-field-box" v-if="item.type == 'add-more'">
                        <v-select
                          v-model="item.name"
                          :items="item.members"
                          item-value="text"
                          item-text="text"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                           @change="getRelationship($event,index)"
                          solo
                        ></v-select>
                      </div>
                       <div class="input-field-box" v-else>
                        <v-text-field
                          type="text"
                          v-model="item.name"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                      </div>
                      </v-col>
                    <v-col class="col-sm-6 col-md-4">
                      <p>RELATONSHIP</p>
                      <v-select  
                        class="relation_col"
                        v-model="item.relation"
                        :items="relation_list"
                        id="will_creation_memeber"
                        item-value="name"
                        item-text="name"
                        placeholder="Choose Relation"
                        solo
                      ></v-select>
                    </v-col>  
                  
                    <v-col md="4" sm="6" cols="12">
                      <p>PERCENTAGE (%)</p>
                       <v-text-field
                          type="number"
                          v-model="item.percentage"
                          outlined
                          dense
                          placeholder="Mrs. XXX"
                          solo
                        ></v-text-field>
                    </v-col>
                  <a style="color:red; margin-bottom:20px; margin-top:0px;" @click="removeNominee(index)">- REMOVE </a>
                  <!-- <v-btn style="color:red;"  @click="removeNominee(index)"
                      >- Remove</v-btn
                    >  -->
                  </v-row>
                  <div class="hor-line"></div>
                </div>
              <button @click="addNominee('add-more')" style="color:blue;">+ ADD NOMINEE</button
                        >
                <button @click="addNominee('add-other')" style="color:orange;margin-left:20px">+ ADD OTHER NOMINEE</button
                        >
                <div class="button-group">
                  <button class="btn save-btn" @click="saveDetails('other')" >
                    SAVE DETAILS
                  </button>
                    <button class="btn cancle-btn" @click="cancelDetails()">CANCEL</button>
                </div>
              </div>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
        <!-- <div class="button-group">
          <button class="btn cancle-btn">CANCEL</button>
          <button class="btn save-btn">SAVE</button>
        </div> -->
      </v-app>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { Auth } from "aws-amplify";
import axios from "axios";
export default {
  props: ['relation_list'],
  data: (instance) => ({
    three_dots: process.env.VUE_APP_ROOT_ICONS_URL + "three_dots.png",
    edit_pic: process.env.VUE_APP_ROOT_ICONS_URL + "edit.png",
    delete_pic: process.env.VUE_APP_ROOT_ICONS_URL + "delete.png",
    update_pic: process.env.VUE_APP_ROOT_ICONS_URL + "update.png",
    item: [],
    hideShow: false,
    readonly: false,
    will_id:'',
    member_id:'',
    hideShowId: "",
    deposit_items: [],
    deposit_type:'',
    name: "",
    relation: "",
    member: [],
    percentage: "",
    items: [],
    privatestock_type:[],
    selectedMembers: [],
    private_unit:[],
    options: [
      { text: "MALE", value: "MALE" },
      { text: "FEMALE", value: "FEMALE" },
      { text: "OTHER", value: "OTHERS" },
    ],

    headers1: [
      {text: "Deposit/Scheme", align: "start",sortable: false,value: "form_name",},
      {text: "Account No.",align: "start",sortable: false,value: "account_no",},
      {text: "No. of Nominees",align: "start",sortable: false,value: "saved_nominees.length",},
      {text: "Nominees",align: "start",sortable: false,value: "nominee_name",},
      {text: "% Share",align: "start",sortable: false,value: "share_to_bequeath",},
      {text: "Relationship",align: "start",sortable: false,value: "relationship",},
      { text: "Actions", value: "actions", sortable: false },
    ],
    headers2: [
      {text: "Stock Type",align: "start",sortable: false,value: "form_name",},
      {text: "Stock Name",align: "start",sortable: false,value: "bank_name",},
      {text: "No. of Nominees",align: "start",sortable: false,value: "saved_nominees.length",},
      {text: "Nominees",align: "start",sortable: false,value: "nominee_name",},
      {text: "%Share",align: "start",sortable: false,value: "share_to_bequeath",},
      {text: "Relationship",align: "start",sortable: false,value: "relationship",},
      { text: "Actions", value: "actions", sortable: false },
    ],
    headers3: [
      {text: "Fund Name",align: "start",sortable: false,value: "scheme_name",},
      { text: "Folio No.", align: "start", sortable: false, value: "folio_no" },
      {text: "No. of Nominees",align: "start",sortable: false,value: "saved_nominees.length",},
      {text: "Nominees",align: "start",sortable: false,value: "nominee_name",},
      {text: "% Share",align: "start",sortable: false,value: "share_to_bequeath",},
      {text: "Relationship",align: "start",sortable: false,value: "relationship",},
      { text: "Actions", value: "actions", sortable: false },
    ],
    headers4: [
      {text: "Bullion Type",align: "start",sortable: false,value: "form_name",},
      {text: "Quantity (in gms)",align: "start",sortable: false,value: "quantity",},
      {text: "No. of Nominees",align: "start",sortable: false,value: "saved_nominees.length",},
      {text: "Nominees",align: "start",sortable: false,value: "nominee_name",},
      {text: "% Share",align: "start",sortable: false,value: "share_to_bequeath",},
      {text: "Relationship",align: "start",sortable: false,value: "relationship",},
      {text: "Actions", value: "actions", sortable: false },
    ],
    headers5: [
      { text: "Bond Name", align: "start", sortable: false, value: "bond" },
      { text: "Units", align: "start", sortable: false, value: "quantity" },
      {text: "No. of Nominees",align: "start",sortable: false,value: "saved_nominees.length",},
      {text: "Nominees",align: "start",sortable: false,value: "nominee_name",},
      {text: "% Share",align: "start",sortable: false,value: "share_to_bequeath",},
      {text: "Relationship",align: "start",sortable: false,value: "relationship",},
      { text: "Actions", value: "actions", sortable: false },
    ],
    headers6: [
      {text: "Real Estate",align: "start",sortable: false,value: "property_type",},
      {text: "Address",align: "start",sortable: false,value: "state",},
      {text: "No. of Nominees",align: "start",sortable: false,value: "saved_nominees.length",},
      {text: "Nominees",align: "start",sortable: false,value: "nominee_name",},
      {text: "% Share",align: "start",sortable: false,value: "share_to_bequeath",},
      {text: "Relationship",align: "start",sortable: false,value: "relationship",},
      { text: "Actions", value: "actions", sortable: false },
    ],
    headers7: [
      {text: "Stock Type",align: "start",sortable: false,value: "commodity_name",},
      { text: "Units", align: "start", sortable: false, value: "unit" },
      {text: "No. of Nominees",align: "start",sortable: false,value: "saved_nominees.length",},
      {text: "Nominees",align: "start",sortable: false,value: "nominee_name",},
      {text: "% Share",align: "start",sortable: false,value: "share_to_bequeath",},
      {text: "Relationship",align: "start", sortable: false, value: "relationship",},
      { text: "Actions", value: "actions", sortable: false },
    ],
    headers8: [
      {text: "Investment Type",align: "start",sortable: false,value: "form_name",},
      {text: "Company/Fund Name",align: "start",sortable: false,value: "pms_name",},
      {text: "No. of Nominees",align: "start",sortable: false,value: "saved_nominees.length",},
      {text: "Nominees",align: "start",sortable: false,value: "nominee_name",},
      {text: "% Share",align: "start",sortable: false,value: "share_to_bequeath",},
      {text: "Relationship",align: "start", sortable: false, value: "relationship",},
      { text: "Actions", value: "actions", sortable: false },
    ],
     headers9: [
      {text: "Asset Type",align: "start",sortable: false,value: "type",},
      {text: "Asset Name/Description",align: "start",sortable: false,value: "description",},
      {text: "Nominee/s",align: "start",sortable: false,value: "saved_nominees.length",},
      {text: "Nominee Name",align: "start",sortable: false,value: "nominee_name",},
      {text: "% Share",align: "start",sortable: false,value: "share_to_bequeath",},
      {text: "Relationship",align: "start", sortable: false, value: "relationship",},
      { text: "Actions", value: "actions", sortable: false },
    ],
    items: [],
    responses: [],
    stock_items: [],
    mutual_fund_items: [],
    bullion_items: [],
    bonds_items: [],
    realestate_items: [],
    commodities_items: [],
    private_investment_items: [],
    isHidden: false,
    isStockHidden: false,
    isFundHidden: false,
    isBullionHidden: false,
    isBondHidden: false,
    isRealEstateHidden: false,
    isCommoditiesHidden: false,
    isPrivateHidden: false,
    isOtherHidden:false,
    depositnominee:[],
    depositnominee_length:[],
    stocknominee:[],
    stocknominee_length:[],
    fundnominee:[],
    fundnominee_length:[],
    bullionnominee:[],
    bullionnominee_length:[],
    bondnominee:[],
    bondnominee_length:'',
    estatenominee:[],
    estatenominee_length:[],
    commoditiesnominee:[],
    commoditiesnominee_length:[],
    privateinvestnominee:[],
    privateinvestnominee_length:[],
    other_asset_items:[],
    relation_list:instance.relation_list,
    deposit_nominee:[],
    saved_nominee:[],
    asset_type:null,
    asset_types:[
      {text:"Painting",value:"Painting"},
      {text:"Vehicle",value:"Vehicle"},
      {text:"Pen",value:"Pen"},
      {text:"Watch",value:"Watch"},
      {text:"Painting",value:"Painting"},
       {text:"Others",value:"Others"},
    ],
    update_nominee:false,
    checked_nominee:'',
  }),
  mounted() {
    this.initialize();
    this.depositDetails();
    

  },
  methods: {
    showHide() {
      this.hideShow = true;
    },
     depositDetails(member_id,will_id) {
      this.member_id = member_id;
      this.will_id = will_id;
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let formdata = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      formdata.append("member_id", member_id);
      formdata.append("will_id", will_id);
      formdata.append("user_name", Auth.currentAuthenticatedUser());
      axios
        .post(process.env.VUE_APP_ROOT_API + "get-investment-details", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          this.getNomineeDetails();
          this.deposit_items = response.data.data.deposit_array;
             this.deposit_items.map(deposit_item=>{
              var nominee = "", relationship = "", share_to_bequeath = ""
                  this.saved_nominee = deposit_item.saved_nominees;
                  this.saved_nominee.map(val=>{
                    nominee += val.nominee_name + '\n';
                    relationship+= val.relationship + '\n';
                    share_to_bequeath+= val.share_to_bequeath + '\n';
                  })
                  deposit_item.nominee_name = nominee;
                  deposit_item.relationship = relationship;
                  deposit_item.share_to_bequeath = share_to_bequeath;
                
          })
           this.other_asset_items = response.data.data.other_asset_array;
             this.other_asset_items.map(other_asset_items=>{
              var nominee = "", relationship = "", share_to_bequeath = ""
                  this.saved_nominee = other_asset_items.saved_nominees;
                  this.id = other_asset_items.id;
                  this.saved_nominee.map(val=>{
                     nominee += val.nominee_name + '\n';
                    relationship+= val.relationship + '\n';
                    share_to_bequeath+= val.share_to_bequeath + '\n';
                  })
                  other_asset_items.nominee_name = nominee;
                  other_asset_items.relationship = relationship;
                  other_asset_items.share_to_bequeath = share_to_bequeath;
                
          })
          this.stock_items = response.data.data.stocks_array;
          this.stock_items.map(stock_item=>{
                  this.saved_nominee = stock_item.saved_nominees;
                  var nominee = "", relationship = "", share_to_bequeath = ""
                  this.saved_nominee.map(val=>{
                     nominee += val.nominee_name + '\n';
                    relationship+= val.relationship + '\n';
                    share_to_bequeath+= val.share_to_bequeath + '\n';
                  })
                  stock_item.nominee_name = nominee;
                  stock_item.relationship = relationship;
                  stock_item.share_to_bequeath = share_to_bequeath;
                  // stock_item.nominee_name = nominee;
          })
          this.mutual_fund_items = response.data.data.mutual_fund_array;
          this.mutual_fund_items.map(mutual_fund_item=>{
                  this.saved_nominee = mutual_fund_item.saved_nominees;
                  var nominee = "", relationship = "", share_to_bequeath = ""
                  this.saved_nominee.map(val=>{
                     nominee += val.nominee_name + '\n';
                    relationship+= val.relationship + '\n';
                    share_to_bequeath+= val.share_to_bequeath + '\n';
                  })
                  mutual_fund_item.nominee_name = nominee;
                  mutual_fund_item.relationship = relationship;
                  mutual_fund_item.share_to_bequeath = share_to_bequeath;
                  // stock_item.nominee_name = nominee;
          })
          this.bullion_items = response.data.data.bullion_array;
          this.bullion_items.map(bullion_item=>{
                  this.saved_nominee = bullion_item.saved_nominees;
                  var nominee = "", relationship = "", share_to_bequeath = ""
                  this.saved_nominee.map(val=>{
                     nominee += val.nominee_name + '\n';
                    relationship+= val.relationship + '\n';
                    share_to_bequeath+= val.share_to_bequeath + '\n';
                  })
                  bullion_item.nominee_name = nominee;
                  bullion_item.relationship = relationship;
                  bullion_item.share_to_bequeath = share_to_bequeath;
                  // bullion_item.nominee_name = nominee;
          })
          this.bonds_items = response.data.data.bonds_array;
          this.bonds_items.map(bonds_item=>{
                  this.saved_nominee = bonds_item.saved_nominees;
                  var nominee = "", relationship = "", share_to_bequeath = ""
                  this.saved_nominee.map(val=>{
                     nominee += val.nominee_name + '\n';
                    relationship+= val.relationship + '\n';
                    share_to_bequeath+= val.share_to_bequeath + '\n';
                  })
                  bonds_item.nominee_name = nominee;
                  bonds_item.relationship = relationship;
                  bonds_item.share_to_bequeath = share_to_bequeath;
                  // bonds_item.nominee_name = nominee;
          })
          this.realestate_items = response.data.data.realestate_array;
          this.realestate_items.map(realestate_item=>{
                  this.saved_nominee = realestate_item.saved_nominees;
                  var nominee = "", relationship = "", share_to_bequeath = ""
                  this.saved_nominee.map(val=>{
                     nominee += val.nominee_name + '\n';
                    relationship+= val.relationship + '\n';
                    share_to_bequeath+= val.share_to_bequeath + '\n';
                  })
                  realestate_item.nominee_name = nominee;
                  realestate_item.relationship = relationship;
                  realestate_item.share_to_bequeath = share_to_bequeath;
                  // realestate_item.nominee_name = nominee;
          })
          this.commodities_items = response.data.data.commodities_array;
          this.commodities_items.map(commodities_item=>{
                  this.saved_nominee = commodities_item.saved_nominees;
                  var nominee = "", relationship = "", share_to_bequeath = ""
                  this.saved_nominee.map(val=>{
                    nominee += val.nominee_name + '\n';
                    relationship+= val.relationship + '\n';
                    share_to_bequeath+= val.share_to_bequeath + '\n';
                  })
                  commodities_item.nominee_name = nominee;
                  commodities_item.relationship = relationship;
                  commodities_item.share_to_bequeath = share_to_bequeath;
                  // commodities_item.nominee_name = nominee;
          })
          this.private_investment_items = response.data.data.private_investment_array;
          this.private_investment_items.map(private_investment_item=>{
                  this.saved_nominee = private_investment_item.saved_nominees;
                  var nominee = "", relationship = "", share_to_bequeath = ""
                  this.saved_nominee.map(val=>{
                    nominee += val.nominee_name + '\n';
                    relationship+= val.relationship + '\n';
                    share_to_bequeath+= val.share_to_bequeath + '\n';
                  })
                  private_investment_item.nominee_name = nominee;
                  private_investment_item.relationship = relationship;
                  private_investment_item.share_to_bequeath = share_to_bequeath;
          })
        });
    },
    initialize() {
	    Auth.currentAuthenticatedUser({
				bypassCache: false
			})
		  .then(user => {	
				this.user_name = user.attributes["custom:name"];
		  })
	  },
    editItem(item) {
      this.isHidden = !this.isHidden;
      this.form_name = item.form_name;
      this.account_no = item.account_no;
      this.bank_name = item.bank_name;
      this.depositnominee_length = item.saved_nominees.length;
      // this.deposit_nominee = item.nominee;
      this.deposit_nominee = []
      this.saved_nominee = item.saved_nominees;
      let member = [];
      this.nominee_list.forEach(value => {
      member.push({value:value.id,text:value.name})
      })
      this.saved_nominee.forEach(element =>{
      let ob = {
          name:element.nominee_name,
          relation: element.relationship,
          percentage: element.share_to_bequeath,
          members:member
        }
        if(!this.nominee_list.some(data => data.name === element.nominee_name)){
          ob.type = 'add-other'
        }
        else{
          ob.type = 'add-more'
        }
        this.deposit_nominee.push(ob)
      
      })
    }, 
    editStockItem(item) {
      this.isStockHidden = !this.isStockHidden;
      this.stock_type = item.form_name;
      this.stock_name = item.bank_name;
      this.stocknominee_length = item.saved_nominees.length;
     this.deposit_nominee = []
      this.saved_nominee = item.saved_nominees;
      let member = [];
      this.nominee_list.forEach(value => {
      member.push({value:value.id,text:value.name})
      })
      this.saved_nominee.forEach(element =>{
      let ob = {
            name:element.nominee_name,
            relation: element.relationship,
            percentage: element.share_to_bequeath,
            members:member
        }
        if(!this.nominee_list.some(data => data.name === element.nominee_name)){
          ob.type = 'add-other'
        }
        else{
          ob.type = 'add-more'
        }
        this.deposit_nominee.push(ob)
      
      })
    },
    editFundItem(item) {
      this.isFundHidden = !this.isFundHidden;
      this.form_name = item.scheme_name;
      this.folio_no = item.folio_no;
      this.fundnominee_length = item.saved_nominees.length;
      this.deposit_nominee = []
      this.saved_nominee = item.saved_nominees;
      let member = [];
      this.nominee_list.forEach(value => {
      member.push({value:value.id,text:value.name})
      })
      this.saved_nominee.forEach(element =>{
      let ob = {
            name:element.nominee_name,
            relation: element.relationship,
            percentage: element.share_to_bequeath,
            members:member
        }
        if(!this.nominee_list.some(data => data.name === element.nominee_name)){
          ob.type = 'add-other'
        }
        else{
          ob.type = 'add-more'
        }
        this.deposit_nominee.push(ob)
      
      })
    },
    editBullionItem(item) {
      this.isBullionHidden = !this.isBullionHidden;
      this.bullion_type = item.form_name;
      this.bullion_quantity = item.quantity;
      this.bullionnominee_length = item.saved_nominees.length;
      this.deposit_nominee = []
      this.saved_nominee = item.saved_nominees;
     let member = [];
      this.nominee_list.forEach(value => {
      member.push({value:value.id,text:value.name})
      })
      this.saved_nominee.forEach(element =>{
      let ob = {
            name:element.nominee_name,
            relation: element.relationship,
            percentage: element.share_to_bequeath,
            members:member
        }
        if(!this.nominee_list.some(data => data.name === element.nominee_name)){
          ob.type = 'add-other'
        }
        else{
          ob.type = 'add-more'
        }
        this.deposit_nominee.push(ob)
      
      })
    },
    editBondItem(item) {
      this.isBondHidden = !this.isBondHidden;
      this.bond_name = item.bond;
      this.bond_unit = item.quantity;
      this.bondnominee_length = item.saved_nominees.length;
      this.deposit_nominee = []
      this.saved_nominee = item.saved_nominees;
      let member = [];
      this.nominee_list.forEach(value => {
      member.push({value:value.id,text:value.name})
      })
      this.saved_nominee.forEach(element =>{
      let ob = {
            name:element.nominee_name,
            relation: element.relationship,
            percentage: element.share_to_bequeath,
            members:member
        }
        if(!this.nominee_list.some(data => data.name === element.nominee_name)){
          ob.type = 'add-other'
        }
        else{
          ob.type = 'add-more'
        }
        this.deposit_nominee.push(ob)
      
      })
    },
    editRealEstateItem(item) {
      this.isRealEstateHidden = !this.isRealEstateHidden;
      this.property_type = item.property_type;
      this.state = item.state;
      this.estatenominee_length = item.saved_nominees.length;
      this.deposit_nominee = []
      this.saved_nominee = item.saved_nominees;
      let member = [];
      this.nominee_list.forEach(value => {
      member.push({value:value.id,text:value.name})
      })
      this.saved_nominee.forEach(element =>{
      let ob = {
            name:element.nominee_name,
            relation: element.relationship,
            percentage: element.share_to_bequeath,
            members:member
        }
        if(!this.nominee_list.some(data => data.name === element.nominee_name)){
          ob.type = 'add-other'
        }
        else{
          ob.type = 'add-more'
        }
        this.deposit_nominee.push(ob)
      
      })
    },
    editCommoditiesItem(item) {
      this.isCommoditiesHidden = !this.isCommoditiesHidden;
      this.commodity_name = item.commodity_name;
      this.commodity_unit = item.unit;
      this.commoditiesnominee_length = item.saved_nominees.length;
     this.deposit_nominee = []
      this.saved_nominee = item.saved_nominees;
      let member = [];
      this.nominee_list.forEach(value => {
      member.push({value:value.id,text:value.name})
      })
      this.saved_nominee.forEach(element =>{
      let ob = {
            name:element.nominee_name,
            relation: element.relationship,
            percentage: element.share_to_bequeath,
            members:member
        }
        if(!this.nominee_list.some(data => data.name === element.nominee_name)){
          ob.type = 'add-other'
        }
        else{
          ob.type = 'add-more'
        }
        this.deposit_nominee.push(ob)
      
      })
    },
    editPrivateItem(item) {
      this.isPrivateHidden = !this.isPrivateHidden;
      this.pms_form_name = item.form_name;
      this.pms_name = item.pms_name;
      this.privateinvestnominee_length = item.saved_nominees.length;
      this.deposit_nominee = []
      this.saved_nominee = item.saved_nominees;
      let member = [];
      this.nominee_list.forEach(value => {
      member.push({value:value.id,text:value.name})
      })
      this.saved_nominee.forEach(element =>{
      let ob = {
            name:element.nominee_name,
            relation: element.relationship,
            percentage: element.share_to_bequeath,
            members:member
        }
        if(!this.nominee_list.some(data => data.name === element.nominee_name)){
          ob.type = 'add-other'
        }
        else{
          ob.type = 'add-more'
        }
        this.deposit_nominee.push(ob)
      
      })
    },
    editOtherItem(item){
      this.isOtherHidden = !this.isOtherHidden;
      this.readonly = true;
      this.asset_type = item.type;
      this.asset_name = item.description;
      this.assetnominee_length = item.saved_nominees.length;
      this.deposit_nominee = []
      this.saved_nominee = item.saved_nominees;
      let member = [];
      this.nominee_list.forEach(value => {
      member.push({value:value.id,text:value.name})
      })
      this.saved_nominee.forEach(element =>{
      let ob = {
            name:element.nominee_name,
            relation: element.relationship,
            percentage: element.share_to_bequeath,
            members:member
        }
        if(!this.nominee_list.some(data => data.name === element.nominee_name)){
          ob.type = 'add-other'
        }
        else{
          ob.type = 'add-more'
        }
        this.deposit_nominee.push(ob)
      
      })
    },
    deleteOtherItem(item){
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let formdata = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      formdata.append("will_id", this.will_id);
      formdata.append("id", item.id);
       axios
        .post(process.env.VUE_APP_ROOT_API + "delete-investment-data", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          console.log(response,'response')
          if(response.data.status == 'success'){
              swal.fire({
                title:'Data Deleted Successfully',
                icon:'success'
              })
            this.depositDetails(this.member_id,this.will_id); 
          }
       })
     },
    saveDetails(type)
    {
    if(this.deposit_nominee.length == 0){
         swal.fire({
                text:' Please Add AtLeast 1 nominee',
                icon:'warning'
              })
      }
     else{
      let totalPercentage = 0;
    
      this.deposit_nominee.forEach(val=>{
      totalPercentage += parseInt(Number(val.percentage));
      })
      this.total_inputs = totalPercentage;
      if(this.total_inputs != 100 && this.total_inputs !='')
      {
        swal.fire({
          title:"Error",
          text:"Sum of percentage must be 100",
          icon:"warning",
        })
      }
      else if(this.total_inputs == 0)
      {
        swal.fire({
          title:"Error",
          text:"Percentage Field is Required",
          icon:"warning",
        })
      }
      else{
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let formdata = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      if(type == 'deposit')
      {
      this.isHidden = false;
      formdata.append("investment_type", this.form_name);
      formdata.append("asset_type_id", 1);
      formdata.append("account_no", this.account_no);
      formdata.append("bank_name", this.bank_name);
      }
      else if(type == 'stock')
      {
      this.isStockHidden = false;
      formdata.append("investment_type", this.stock_type);
      formdata.append("asset_type_id", 2);
      formdata.append("bank_name", this.stock_name);
      }
      else if(type == 'mutual_fund')
      {
      this.isFundHidden = false;
     formdata.append("investment_type", this.form_name);
      formdata.append("asset_type_id", 3);
      formdata.append("account_no", this.folio_no);
      }
      else if(type == 'bullion')
      {
        console.log(this.bullion_quantity)
      this.isBullionHidden = false;
      formdata.append("investment_type", this.bullion_type);
      formdata.append("asset_type_id", 4);
      formdata.append("unit", this.bullion_quantity);
      }
      else if(type == 'bonds')
      {
      this.isBondHidden = false;
      formdata.append("investment_type", this.bond_name);
      formdata.append("asset_type_id", 5);
      formdata.append("unit", this.bond_unit);
      }
      else if(type == 'real_estate')
      {
      this.isRealEstateHidden = false;
      formdata.append("investment_type", this.property_type);
      formdata.append("asset_type_id", 6);
      formdata.append("address", this.state);
      }
      else if(type == 'commodity')
      {
      this.isCommoditiesHidden = false;
      formdata.append("investment_type", this.commodity_name);
      formdata.append("asset_type_id", 7);
      formdata.append("unit", this.commodity_unit);
      }
      else if(type == 'pms') 
      {
      this.isPrivateHidden = false;
      formdata.append("investment_type", this.pms_form_name);
      formdata.append("asset_type_id", 8);
      formdata.append("bank_name", this.pms_name);
      }
      else if(type == 'other')
      {
      this.isPrivateHidden = false;
      formdata.append("investment_type", this.asset_type);
      formdata.append("asset_type_id", 9);
      formdata.append("bank_name", this.asset_name);
      }
      formdata.append("will_id", this.will_id);
      formdata.append("no_of_nominee", this.deposit_nominee.length);
      formdata.append("nominee_details", JSON.stringify(this.deposit_nominee));

      axios
        .post(process.env.VUE_APP_ROOT_API + "save-investment-details", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          console.log(response,'response')
          if(response.data.status == 'success'){
              swal.fire({
                title:'Nominee Details Added Successfully',
                icon:'success'
              })
                  
          this.depositDetails(this.member_id,this.will_id);    
          this.isHidden = false;
          this.isStockHidden = false; 
          this.isFundHidden = false;
          this.isBondHidden = false;
          this.isBullionHidden = false;
          this.isCommoditiesHidden = false;
          this.isRealEstateHidden = false;
          this.isPrivateHidden = false;
          this.isOtherHidden = false;
          }
        })
       }
     }
   },

    cancelDetails()
    {
      this.isHidden = false;
      this.isStockHidden = false; 
      this.isFundHidden = false;
      this.isBondHidden = false;
      this.isBullionHidden = false;
      this.isCommoditiesHidden = false;
      this.isRealEstateHidden = false;
      this.isPrivateHidden = false;
      this.isOtherHidden = false;
    },
    getNomineeDetails(){
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let formdata = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      formdata.append("member_id", this.member_id);
       axios
        .post(process.env.VUE_APP_ROOT_API + "get-nominee-list", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          this.nominee_list = response.data.data;
          // console.log(  this.nominee_list ,'response')
          // let member = [];
          // this.nominee_list.forEach(value => {
          // member.push({value:value.id,text:value.name})
          // })
          // this.deposit_nominee.push({members:member,name:'',relation: "", percentage: "",type:''})
       })
    },
    updateAllNominee(){
      if(this.update_nominee ==false)
      {
      this.$loading(true);
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let formdata = {
        aws_cognito_id:cognito_idp,
        will_id:this.will_id,
        deposit_items:this.deposit_items,
        stock_items:this.stock_items,
        mutual_fund_items:this.mutual_fund_items,
        bullion_items:this.bullion_items,
        bonds_items:this.bonds_items,
        realestate_items:this.realestate_items,
        commodities_items:this.commodities_items,
        private_investment_items:this.private_investment_items,
        other_asset_items:this.other_asset_items
      }
      axios
        .post(process.env.VUE_APP_ROOT_API + "apply-nominee-for-all", formdata)
        .then((response) => {
          this.$loading(false);
          if(response.data.status == 'success'){
            this.depositDetails(this.member_id,this.will_id); 
          }
      })
      }
     
    },
    getRelationship(name,index)
    {
      let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
      var formdata = new FormData()
      formdata.append("aws_cognito_id", cognito_idp);
      formdata.append("will_id", this.will_id);
      formdata.append("name", name);
      axios.post(process.env.VUE_APP_ROOT_API + "get-relationship", formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
      })
      .then((response) => {
        let member = [];
        let relation = response.data.relation;
        this.deposit_nominee[index].relation  = relation;

      });
    },
    addNominee(type) {
        let member = [];
        let selectedMembers = [];
        this.deposit_nominee.forEach(item => {
          selectedMembers.push(item.name)
        })
        this.nominee_list.forEach(value => {
          let name = value.name;
          if(!selectedMembers.includes(name)){
            member.push({text:value.name, value:value.id})
          }
        })
        this.deposit_nominee.push({members:member,name:'',relation: "", percentage: "",type:type})

    },
  
    removeNominee(index) {
        this.deposit_nominee.splice(index,1);
        // this.getNomineeDetails()
    },
    addOtherAssets(){
     this.isOtherHidden = !this.isOtherHidden;
       this.deposit_nominee =[];
       this.asset_type='',
       this.asset_name=''
       
    },
    save(){
      if(this.deposit_nominee.length == 0){
         swal.fire({
                title:'Add AtLeast One nominee',
                icon:'warning'
              })
      }
    },
  },
};
</script>

<style>
.img-box {
  margin-left: 750px;
  display: flex;
}
.relation_list{
    border: 1px solid #9b9595;
     padding-top:10px;
    margin: 0px;
    border-radius: 5px;
}
.relation_col{
    margin-top:10px;
   
}
.label-checkbox {
  margin-right: 0.87rem;
  margin-top:5px;
  /* margin-left:75%; */
  border: 1px solid #2e4371;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 5px 10px;
  text-align: center;
  display: inline-block;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #4273DE;
}
.check-day {
 visibility: hidden;
  position: absolute;
  right: 0;
}
.checked_nominee {
  background: #2e4371;
  color: #fff;
}
.checked_nominee::before {
  content: "✔";
}
</style>
